import { createQueryParams } from './createQueryParams';
export var getEmbedUrl = function getEmbedUrl(_ref) {
  var preproductBaseUrl = _ref.preproductBaseUrl,
      templateKey = _ref.templateKey,
      queryParams = _ref.queryParams;
  var url = "".concat(preproductBaseUrl);

  if (templateKey) {
    url += "/".concat(templateKey);
  }

  if (queryParams) {
    url += "?".concat(createQueryParams(queryParams));
  }

  return url;
};